import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetBuildings_buildingIdHeatingStations = z.any()
export type TagsGetBuildings_buildingIdHeatingStations = z.infer<typeof tagsGetBuildings_buildingIdHeatingStations>

export const paramsGetBuildings_buildingIdHeatingStations = z.object({ "buildingId": z.string().uuid() })
export type ParamsGetBuildings_buildingIdHeatingStations = z.infer<typeof paramsGetBuildings_buildingIdHeatingStations>

export const responseGetBuildings_buildingIdHeatingStations = z.object({ "payload": z.object({ "stations": z.array(z.object({ "id": z.string(), "name": z.string(), "latitude": z.number(), "longitude": z.number(), "elevation": z.union([z.number(), z.null()]), "observedFrom": z.union([z.string().date(), z.null()]), "observedTo": z.union([z.string().date(), z.null()]) })), "error": z.union([z.string(), z.null()]), "refreshing": z.boolean() }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetBuildings_buildingIdHeatingStations = z.infer<typeof responseGetBuildings_buildingIdHeatingStations>

interface IGetBuildings_buildingIdHeatingStations extends BaseMethodType {
  tags: TagsGetBuildings_buildingIdHeatingStations,
  params: ParamsGetBuildings_buildingIdHeatingStations,
  response: ResponseGetBuildings_buildingIdHeatingStations
}
export const URL = '/buildings/:buildingId/heating/stations'
export const validation = {
  get: {
    tags: tagsGetBuildings_buildingIdHeatingStations,
    params: paramsGetBuildings_buildingIdHeatingStations,
    response: responseGetBuildings_buildingIdHeatingStations
  }
}
export interface Buildings_buildingIdHeatingStations extends BaseRouteType {
  get: IGetBuildings_buildingIdHeatingStations
}